import { render, staticRenderFns } from "./attachFile.vue?vue&type=template&id=08139494&scoped=true&"
import script from "./attachFile.vue?vue&type=script&lang=js&"
export * from "./attachFile.vue?vue&type=script&lang=js&"
import style0 from "./attachFile.vue?vue&type=style&index=0&id=08139494&prod&scoped=true&lang=scss&"
import style1 from "./attachFile.vue?vue&type=style&index=1&id=08139494&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08139494",
  null
  
)

export default component.exports